<div mat-dialog-actions>
    <div class="loc-heading"> Location Permission Denied </div>
    <p class="p-dailog">foodbud uses this permission to detect your current location and shows you great
        restaurants around you . Are you sure you want to deny this permission?</p>
    <div class="d-flex justify-content-end" style="margin-top: -10px;">
        <button mat-button (click)="imsure()" class="btns">I'M SURE</button>
        <button mat-button class="btns" (click)="retry()">RETRY</button>
    </div>
</div>
<style>
    ::ng-deep.mat-dialog-actions {
        padding: 0px !important;
        display: grid !important;
    }

    .p-dailog {
        color: #626262;
        font-size: 12px;
        letter-spacing: 0.5px;
        line-height: 16px;
        font-family: 'Roboto';
        margin-top: 10px;
    }

    .loc-heading {
        font-size: 16px;
        letter-spacing: 0.3px;
        line-height: 19px;
        color: #3C3C3C;
    }

    .btns {
        color: #FA4747;
        font-size: 12px;
        letter-spacing: 0.5px;
        line-height: 16px;
    }
</style>